module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ef-Fb-Gd.eb930b12.png";